"use client";

import * as React from "react";

import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";

import { Flex } from "../ui.flex";
import { cn } from "../util.cn";

const RadioGroup = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>((props, ref) => {
  return (
    <Flex asChild gap="3" wrap="wrap">
      <RadioGroupPrimitive.Root
        {...props}
        ref={ref}
      />
    </Flex>
  );
});
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;

const RadioGroupItem = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>((props, ref) => {
  const { className, ...itemProps } = props;
  return (
    <RadioGroupPrimitive.Item
      {...itemProps}
      className={cn(
        "relative rounded-2 border border-gray-6 px-2 py-1",
        `
          data-[state=checked]:outline
          data-[state=checked]:outline-2
          data-[state=checked]:outline-offset-2
          data-[state=checked]:outline-accent-8
        `,
        `
          disabled:cursor-not-allowed disabled:border-gray-5
          disabled:text-gray-6
        `,
        className,
      )}
      ref={ref}
    />
  );
});
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

export {
  RadioGroup as Root,
  RadioGroupItem as Item,
};
